export default __webpack_public_path__ + "static/media/Video3.b528bd15.mov";